module.exports = __webpack_public_path__ + "static/img/m10.c7f9206.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page/m10.jpg
// module id = cVqZ
// module chunks = 1